<template>
  <section id="donate">
    <div class="container">
      <h1 class="section-title">Support Our Mission</h1>

      <div class="donate-intro">
        <p class="donate-description">
          Stardust Cookie Cutter is free, open-source, and community-funded. Your support helps us continue building privacy tools that empower users worldwide.
        </p>
      </div>

      <DonateCrypto />

      <div class="donate-footer">
        <p class="contact-text">
          Need other payment options?
          <a href="mailto:hey@strdst.org" class="contact-link">Contact us</a>
        </p>
      </div>
    </div>
  </section>
</template>

<script>
import DonateCrypto from "./DonateCrypto.vue";

export default {
  name: "DonateSection",
  components: {
    DonateCrypto,
  },
};
</script>

<style scoped>
section {
  background-color: var(--color-charcoal-mist-70);
  backdrop-filter: var(--blur-glassmorphism);
  filter: var(--shadow-card);
  padding: var(--spacing-3xl) var(--container-padding);
  margin-bottom: 0;
  position: relative;
  z-index: 1;
}

.container {
  max-width: var(--container-max-width);
  margin: 0 auto;
}

.section-title {
  text-align: center;
  color: var(--color-stardust-gold);
  font-size: clamp(32px, 4.5vw, 42px);
  font-weight: var(--font-weight-bold);
  margin: 0 0 var(--spacing-xl) 0;
}

.donate-intro {
  max-width: 700px;
  margin: 0 auto var(--spacing-3xl);
  text-align: center;
}

.donate-description {
  font-size: clamp(15px, 1.8vw, 17px);
  line-height: 1.7;
  color: var(--color-soft-white);
  margin: 0 0 var(--spacing-md) 0;
  font-family: var(--font-secondary);
}

.donate-footer {
  text-align: center;
  margin-top: var(--spacing-3xl);
  padding-top: var(--spacing-2xl);
  border-top: 1px solid var(--color-border-subtle);
}

.contact-text {
  font-size: 15px;
  color: var(--color-muted-white-90);
  margin: 0;
}

.contact-link {
  color: var(--color-stardust-gold);
  text-decoration: none;
  font-weight: var(--font-weight-medium);
  transition: var(--transition-quick);
  border-bottom: 1px solid transparent;
}

.contact-link:hover {
  color: var(--color-stardust-gold-light);
  border-bottom-color: var(--color-stardust-gold-light);
}

.contact-link:focus-visible {
  outline: 2px solid var(--color-stardust-gold);
  outline-offset: 3px;
  border-radius: 3px;
}

@media (max-width: 768px) {
  section {
    padding: var(--spacing-2xl) var(--container-padding);
  }

  .donate-intro {
    margin-bottom: var(--spacing-2xl);
  }

  .donate-footer {
    margin-top: var(--spacing-2xl);
    padding-top: var(--spacing-xl);
  }
}

@media (max-width: 500px) {
  section {
    padding: 30px var(--spacing-md);
  }
}
</style>